// @flow

import * as React from 'react';
import { Route, Link } from 'react-router-dom';

import { Header } from './components/Header';
import { Home } from './routeComponents/Home';
import { About } from './routeComponents/About';


import brace from 'brace'; 
import AceEditor from 'react-ace'; 
 
import 'brace/mode/jsx'; 
import 'brace/theme/monokai'; 

import './App.css';

import AdsumItemCarousel from "@adactive/arc-itemcarousel";
import ACA from '../src/services/ClientAPI';
import _ from 'lodash';

type PropsType = {||};

class App extends React.Component<PropsType> {

    constructor(props) {
        super(props);

        this.onItemClicked = this.onItemClicked.bind(this);
        this.getItemsWithLogo = this.getItemsWithLogo.bind(this);
        this.getItemsWithoutLogo = this.getItemsWithoutLogo.bind(this);
    }

    onItemClicked(item) {
        console.log("[ITEM CLICKED] :: ", item);
    }

    componentDidMount() {
        console.log("[ACA] : ", ACA);
    }

    getItemsWithLogo() {
        let itemsWithLogo = ACA.getAllCategories();
        _.map(itemsWithLogo, (item) => {
            if (item.logo && item.logo.value) {
                item.logo = ACA.getFile(item.logo.value);
            } else {
                item.logo = null;
            }
            return item
        });

        return itemsWithLogo;
    }

    getItemsWithoutLogo() {
        let itemsWithoutLogo = ACA.getAllCategories();

        _.map(itemsWithoutLogo, (item) => {
            delete item['logo'];
            return item
        });

        return itemsWithoutLogo;
    }


    render() {
        const itemsWithoutLogo = this.getItemsWithoutLogo();
        const itemsWithLogo = this.getItemsWithLogo();

        const listWrapperCSS = {
            position: "relative",
            left: "15px"
        }

        const thumbnailWrapperCSS = {
            height: "100px",
            width: "180px"
        }

        const logoWrapperCSS = {
            background: "black",
            color: "white"
        }

        const logoCSS = {
            height: "50px"
        }

        const titleWrapperCSS = {
            background: "grey",
            color: "white"
        }

        const dashCSS = {
            borderColor: "red"
        }

        const titleCSS = {
            fontSize: "1em",
            color: "white"
        }

        const buttonStyle = {
            border: "0",
            background: "transparent",
            fontSize: "24px",
            lineHeight: "line-height",
            padding: "10px",
            display: "block",
            outline: "0"
        }

        const renderCenterLeftControls = ({ previousSlide }) =>
            <button style={buttonStyle} onClick={previousSlide}>
                <img src="assets/arrow-left.png" />
            </button>;

        const renderCenterRightControls = ({ nextSlide }) =>
            <button style={buttonStyle} onClick={nextSlide}>
                <img src="assets/arrow-right.png" />
            </button>;

        const carouselOptions = {
            renderCenterLeftControls: renderCenterLeftControls,
            renderCenterRightControls: renderCenterRightControls,
            wrapAround: true
        };

        return (
            <div className="App">
                <Header logo={"http://adactivesas.github.io/adsum-react-components/logo.jpg"} />
                <div>
                    <div className="wrapper">
                        <div className="comp">
                            <AdsumItemCarousel
                                isOpen={true}
                                items={itemsWithoutLogo}
                                itemsPerPage={9}
                                onItemClicked={this.onItemClicked}
                                listWrapperCSS={listWrapperCSS}
                            />
                        </div>
                        <div className="code">
                            <AceEditor
                                mode="jsx"
                                theme="monokai"
                                name="UNIQUE_ID_OF_DIV"
                                editorProps={{$blockScrolling: true}}
                                fontSize={14}
                                value={`import AdsumItemCarousel from "@adactive/arc-itemcarousel";
...

onItemClicked(item) {
    console.log("[ITEM CLICKED] :: ", item);
}

const itemsWithoutLogo = [
    {
        name: 'Food'
    },
    ...
    {
        name: 'Carpark'
    }
];

const listWrapperCSS = {
    position: "relative",
    left: "5px"
}

<AdsumItemCarousel
    isOpen={true}
    items={itemsWithoutLogo}
    itemsPerPage={9}
    onItemClicked={this.onItemClicked}
    listWrapperCSS={listWrapperCSS}
/>
`}
                                height='650px'
                                width='700px'
                            />
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="comp comp-12">
                            <AdsumItemCarousel
                                isOpen={true}
                                items={itemsWithLogo}
                                itemsPerPage={12}
                                onItemClicked={this.onItemClicked}
                                logoWrapperCSS={logoWrapperCSS}
                                logoCSS={logoCSS}
                                dashCSS={dashCSS}
                                titleWrapperCSS={titleWrapperCSS}
                                titleCSS={titleCSS}
                                thumbNailWrapperCSS={thumbnailWrapperCSS}
                                carouselOptions={carouselOptions}
                                listWrapperCSS={listWrapperCSS}
                            />
                        </div>
                        <div className="code">
                            <AceEditor
                                mode="jsx"
                                theme="monokai"
                                name="UNIQUE_ID_OF_DIV"
                                editorProps={{$blockScrolling: true}}
                                fontSize={14}
                                value={`import AdsumItemCarousel from "@adactive/arc-itemcarousel";
...

onItemClicked(item) {
    console.log("[ITEM CLICKED] :: ", item);
}

const itemsWithLogo = [
    {
        name: 'Food',
        logo: {
            uri: url of image
        }
    },
    ...
    {
        name: 'Carpark',
        logo: {
            uri: url of image
        }
    }
];

const listWrapperCSS = {
    position: "relative",
    left: "15px"
}

const thumbnailWrapperCSS = {
    height: "100px",
    width: "180px"
}

const logoWrapperCSS = {
    background: "black",
    color: "white"
}

const logoCSS = {
    height: "50px"
}

const titleWrapperCSS = {
    background: "grey",
    color: "white"
}

const dashCSS = {
    borderColor: "red"
}

const titleCSS = {
    fontSize: "1em",
    color: "white"
}

const buttonStyle = {
    border: "0",
    background: "transparent",
    fontSize: "24px",
    lineHeight: "line-height",
    padding: "10px",
    display: "block",
    outline: "0"
}

const renderCenterLeftControls = ({ previousSlide }) =>
    <button style={buttonStyle} onClick={previousSlide}>
        <img src="assets/arrow-left.png" />
    </button>;

const renderCenterRightControls = ({ nextSlide }) =>
    <button style={buttonStyle} onClick={nextSlide}>
        <img src="assets/arrow-right.png" />
    </button>;

const carouselOptions = {
    renderCenterLeftControls: renderCenterLeftControls,
    renderCenterRightControls: renderCenterRightControls,
    wrapAround: true //For infinite scrolling
};

<AdsumItemCarousel
    isOpen={true}
    items={itemsWithLogo}
    itemsPerPage={12}
    onItemClicked={this.onItemClicked}
    logoWrapperCSS={logoWrapperCSS}
    logoCSS={logoCSS}
    dashCSS={dashCSS}
    titleWrapperCSS={titleWrapperCSS}
    titleCSS={titleCSS}
    thumbNailWrapperCSS={thumbnailWrapperCSS}
    carouselOptions={carouselOptions}
/>

`}
                                height='500px'
                                width='700px'
                            />
                        </div>
                    </div>
                </div>

                {/*<nav>
                    <Link to="/">Home</Link>
                    <Link to="/about-us">About</Link>
                </nav>
                <main>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/about-us" component={About} />
                </main>*/}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js